import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { ClickBase } from "./ClickBase";
export const buttonBaseClasses = {
    root: "MinervaButtonBase-root",
};
export const ButtonBase = memo(forwardRef(({ as = "button", href, className, ...props }, ref) => {
    return (_jsx(ClickBase, { ref: ref, as: href ? "a" : as, href: href, type: "button", role: "button", className: clsx([className, buttonBaseClasses.root]), ...props }));
}));
//# sourceMappingURL=ButtonBase.js.map